import { api } from '@/helpers/api'
import type { UserAttributes } from '@/types/UserAttributes'
import type { ClinicAttributes } from '@/types/ClinicAttributes'
import type { NotificationAttributes } from '@/types/NotificationAttributes'
import type { ResourceResponse } from '@/types/responses/ResourceResponse'

interface AppState {
    alert: { text: string; color: string } | false
    shallContentShowOverlay: boolean
    user?: UserAttributes
    userAuthToken?: string
    activeClinic?: ClinicAttributes
    notifications: NotificationAttributes[]
}

export const useAppStore = defineStore('app', {
    state: (): AppState => ({
        alert: false,
        shallContentShowOverlay: false,
        notifications: [],
    }),

    getters: {
        hasAlert: (state) => state.alert !== false,
    },

    actions: {
        update(data: Partial<AppState>) {
            Object.assign(this, data)
        },

        showAlert(alert: { text: string; color: string }) {
            this.alert = alert

            setTimeout(() => {
                this.alert = false
            }, 10 * 1000)
        },

        async fetchNotifications() {
            const result = await api<ResourceResponse<NotificationAttributes[]>>({
                endpoint: 'notifications',
            })

            if (result.status !== 200) {
                return
            }

            this.notifications = result.data.data
        },

        async markNotificationsRead() {
            const result = await api({
                endpoint: 'notifications/mark-read',
                method: 'post',
            })

            if (result.status !== 204) {
                return
            }

            this.fetchNotifications()
        },
    },
})
